module.exports = __webpack_public_path__ + "static/media/StoreMt.32ef6a15.svg";